export const OPEN_MODAL_POPUP = "OPEN_MODAL_POPUP";
export const CLOSE_MODAL_POPUP = "CLOSE_MODAL_POPUP";

export enum PopupInner {
  Register,
  LogIn,
  ForgottenPassword,
}

export interface ISite {
  popupOpen: boolean;
  popupInner: PopupInner;
  currency: "EUR";
}

export type Photo = {
  url: string;
  title: string;
  description?: string;
  thumbnailUrl?: string;
};

export type Review = {
  date: Date;
  stars: number;
  reviewer: string;
  reviewText: string;
};

export type PreviewPhoto = {
  url: string;
  name: string;
  thumbnailUrl?: string;
  processing?: boolean;
};

export type PatternDifficulty = "easy" | "medium" | "hard";

export type PatternData = {
  _id: string;
  user: string;
  name: string;
  price: number;
  discount: number;
  currency?: "EUR";
  omnibus?: {
    periodDays: number;
    currency: "EUR";
    isReductionActive: boolean;
    campaignStartAt: Date | null;
    windowStart: Date | null;
    windowEnd: Date | null;
    currentEffectivePrice: number | null;
    lowestEffectivePrice: number | null;
    lowestPriceChangedAt: Date | null;
    pointsConsidered: number;
    percentageFromLowest: number;
  };
  priceHistory?: {
    price: number;
    discount: number;
    currency: "EUR";
    changedAt: Date;
    fxSource?: string | null;
    fxTableNo?: string | null;
    fxEffectiveDate?: Date | null;
    fxRateToPLN?: number | null;
  }[];
  displayPricing?: {
    sourceCurrency: "EUR";
    currency: "EUR";
    price: number;
    discount: number;
    effectivePrice: number;
    hasDiscount: boolean;
    isConverted: boolean;
    conversion: {
      source: string;
      table: string;
      tableNo: string | null;
      effectiveDate: Date | null;
      baseCurrency: "PLN";
      rateFromTo: number;
    } | null;
  };
  displayOmnibus?: {
    periodDays: number;
    currency: "EUR";
    isReductionActive: boolean;
    campaignStartAt: Date | null;
    windowStart: Date | null;
    windowEnd: Date | null;
    currentEffectivePrice: number | null;
    lowestEffectivePrice: number | null;
    lowestPriceChangedAt: Date | null;
    pointsConsidered: number;
    percentageFromLowest: number;
    isConverted: boolean;
    conversion: {
      source: string;
      table: string;
      tableNo: string | null;
      effectiveDate: Date | null;
      baseCurrency: "PLN";
      rateFromTo: number;
    } | null;
  };
  previewUrl?: string;
  isEditable?: boolean;
  description: string;
  descriptionLong: string;
  difficulty?: PatternDifficulty;
  photos: Photo[];
  mainPhoto: Photo;
  dateUpdated: Date;
  sizes: string[];
  clients: string[];
  categories: string[];
  fabrics: string[];
  dateCreated: Date;
};

type SocialMediaTypes = {
  [key: string]: string;
};

export type ProfileData = {
  bio: string;
  company: string;
  date: Date;
  handle: string;
  location: string;
  photo: PreviewPhoto;
  products: PatternData[];
  social: SocialMediaTypes;
  user: { _id: string; name: string; avatar: string };
  website: string;
  _id: string;
};

export type CartData = {
  id: string;
  user: string;
  name: string;
  price: number;
  creatorId: {_id: string, name: string, email: string}
  originalPrice?: number | null;
  omnibusLowestPrice?: number | null;
  showPromotionInfo?: boolean;
  showOmnibusInfo?: boolean;
  photo?: Photo;
  profileHandle?: string;
  sizes: string[];
  selectedSize?: string | null;
  cartItemId?: string;
};

export type orderBy = {
  email: string;
  name: string;
  _id: string;
}
